import { Flex, Skeleton } from '@eqi-investimentos/react';

export const ConfirmSendOrderAdvisorSkeleton = () => (
  <Flex flexDir="column" justify="space-between" h="full" gap="m">
    <Flex flexDir="column" gap="m">
      <Skeleton w="full" h="30px" />
      <Flex flexDir="column" gap="m">
        {Array.from({
          length: 5,
        }).map((_, index) => (
          <Flex w="full" justify="space-between" key={index}>
            <Skeleton w="40px" h="30px" />
            <Skeleton w="140px" h="30px" />
          </Flex>
        ))}
      </Flex>
    </Flex>
    <Flex gap="m">
      <Skeleton w="full" h="40px" />
      <Skeleton w="full" h="40px" />
    </Flex>
  </Flex>
);
